<template>
  <div>
    <SearchRow @handleFilter="handleFilter" pageName="menuFavourite" />

    <el-table v-loading="listLoading" :data="favItemList" class="while-data-table">
      <el-table-column label="图片">
        <template slot-scope="scope">
          <div class="item-image">
            <img :src="getImageUrl(scope.row.pocmDTO)" />
          </div>
        </template>
      </el-table-column>
      <el-table-column label="名称" label-class-name="cell-left">
        <template slot-scope="scope">
          <div class="item-name">{{ scope.row.pocmDTO.itemName }}</div>
        </template>
      </el-table-column>
      <el-table-column label="品牌" show-overflow-tooltip>
        <template slot-scope="scope">{{ showBrandName(scope.row.pocmDTO.itemBrandList) }}</template>
      </el-table-column>
      <el-table-column label="价格(不含税)">
        <template slot-scope="scope">
          <div>￥{{ getPrice(scope.row.pocmDTO)  | thousandSymbol}}</div>
          <div
            class="price-msg"
            v-if="scope.row.pocmDTO.priceUnitQuantity !== 1"
          >(每{{ scope.row.pocmDTO.priceUnitQuantity }}个商品{{ getPrice(scope.row.pocmDTO)  | thousandSymbol}}元)</div>
        </template>
      </el-table-column>
      <el-table-column label="税额">
        <template slot-scope="scope">
          <div v-if="scope.row.pocmDTO.pocmPriceType === '01'">￥{{ getTaxPrice(scope.row.pocmDTO)  | thousandSymbol}}</div>
          <div v-else>￥ 0.00</div>
          <div
            class="price-msg"
            v-if="scope.row.pocmDTO.priceUnitQuantity !== 1 && scope.row.pocmDTO.pocmPriceType === '01'"
          >(每{{ scope.row.pocmDTO.priceUnitQuantity }}个商品{{ getTaxPrice(scope.row.pocmDTO) }}元)</div>
        </template>
      </el-table-column>
      <el-table-column label="运费" prop="pocmDTO.extraFee" width="75">
        <template slot-scope="scope">
          <div>￥{{ scope.row.pocmDTO.extraFee  | thousandSymbol}}</div>
          <div
            class="price-msg"
            v-if="scope.row.pocmDTO.priceUnitQuantity !== 1 && scope.row.pocmDTO.extraFee !== 0"
          >(每{{ scope.row.pocmDTO.priceUnitQuantity }}个商品{{ scope.row.pocmDTO.extraFee }}元)</div>
        </template>
      </el-table-column>
      <el-table-column label="数量" width="150">
        <template slot-scope="scope">
          <el-input-number v-model="scope.row.pocmDTO.itemQty" size="mini" :min="1" />
        </template>
      </el-table-column>
      <el-table-column label="价格小计">
        <template slot-scope="scope">￥{{ getItemSumPrice(scope.row.pocmDTO) | thousandSymbol}}</template>
      </el-table-column>
      <el-table-column label="税额小计">
        <template slot-scope="scope">￥{{ getItemSumTaxPrice(scope.row.pocmDTO) | thousandSymbol}}</template>
      </el-table-column>
      <el-table-column label="运费小计">
        <template slot-scope="scope">￥{{ getItemSumExtraPrice(scope.row.pocmDTO) | thousandSymbol}}</template>
      </el-table-column>
      <el-table-column label="操作" width="100">
        <template slot-scope="scope">
          <i class="iconfont iconzu19 cursor" @click="handleForm(scope.row)" title="加入购物车" />
        </template>
      </el-table-column>
    </el-table>

    <el-row v-if="total" class="while-data-table-footer">
      <el-col>
        <el-pagination
          background
          :current-page="queryParam.page"
          :page-size="queryParam.pageSize"
          :total="total"
          layout="total, prev, pager, next"
          @current-change="handleCurrentChange"
        />
      </el-col>
    </el-row>

    <el-dialog title="请选择" :visible.sync="dialogVisible" class="item-box" width="550px">
      <el-row>
        <el-form ref="queryForm" :rules="queryFormRules" :model="queryForm" label-width="150px">
          <el-col class="item-info-radio" :span="24">
            <el-form-item label="品牌" prop="abiBrandId">
              <el-select v-model="queryForm.abiBrandId" @change="getSubBrandList" filterable placeholder="选择品牌" clearable size="small">
                <el-option
                  v-for="(item,index) in itemParBrandList"
                  :label="`${item.abiBrandName} ${item.brandGroup?'-':''} ${item.brandGroup||''}`"
                  :value="item.abiBrandId"
                  :key="index"
                  style="max-width: 400px"
                />
              </el-select>
            </el-form-item>
          </el-col>

          <el-col class="item-info-radio" :span="24" v-if="queryForm.abiBrandId">
            <el-form-item label="子品牌" prop="subBrandId">
              <el-select v-model="queryForm.subBrandId" placeholder="选择子品牌" filterable clearable size="small">
                <el-option
                  v-for="(item,index) in showSubBrandList"
                  :label="`${item.abiBrandName} ${item.brandGroup?'-':''} ${item.brandGroup||''}`"
                  :value="item.abiBrandId"
                  :key="index"
                  style="max-width: 400px"
                />
              </el-select>
            </el-form-item>
          </el-col>

          <el-col class="item-info-radio" :span="24">
            <el-form-item label="MMR12" prop="mmr12">
              <el-select v-model="queryForm.mmr12" placeholder="选择MMR12编码" filterable clearable size="small">
                <el-option
                  v-for="item in mmr12List"
                  :label="`${item.code}-${item.name}`"
                  :value="item.code"
                  :key="item.code"
                  :title="`${item.code}-${item.name}`"
                  style="max-width: 400px"
                />
              </el-select>
            </el-form-item>
          </el-col>

          <el-col class="item-info-radio" :span="24" v-if="queryForm.mmr12">
            <el-form-item label="总账科目" prop="ledgerAccount">
              <el-select v-model="queryForm.ledgerAccount" placeholder="选择总账科目" clearable size="small">
                <el-option
                  v-for="item in ledgerList"
                  :label="`${item.ledgerAccountCode}-${item.ledgerAccountName}`"
                  :value="item.ledgerAccountCode"
                  :key="item.ledgerAccountCode"
                  :title="`${item.ledgerAccountCode}-${item.ledgerAccountName}`"
                  style="max-width: 400px"
                />
              </el-select>
            </el-form-item>
          </el-col>

          <el-col class="item-info-radio" :span="24">
            <el-form-item label="工厂" prop="companyEntityId">
              <el-select v-model="queryForm.companyEntityId" placeholder="选择工厂" clearable size="small" filterable>
                <el-option
                  v-for="item in entityList"
                  :label="item.entityCode + '-' + item.entityName"
                  :value="item.entityId"
                  :key="item.entityId"
                />
              </el-select>
            </el-form-item>
          </el-col>

          <el-col class="item-btn">
            <el-button class="btn-orange-plain" :loading="saveLoading" @click="saveSelection">确 定</el-button>
            <el-button class="btn-grey" @click="dialogVisible = false">取 消</el-button>
          </el-col>
        </el-form>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import SearchRow from './search-row'
import itemApi from '@/api/item'
import baseApi from '@/api/base'
import { commonUtils } from '@/utils/common'
import { create, all } from 'mathjs/number'
const math = create(all)

export default {
  name: 'favourite-item-list',
  components: {
    SearchRow
  },
  props: {
    itemType: {
      type: String,
      default: 'menu'
    }
  },
  data () {
    return {
      saveLoading: false,
      listLoading: false,
      dialogVisible: false,
      queryParam: {
        page: 1,
        pageSize: 10,
        isMenu: '',
        isPrints: '',
        abiBrandId: '',
        channel: '',
        categoryId: '',
        produceSupplierId: '',
        keyword: '',
        minPrice: '',
        maxPrice: '',
        entityId: ''
      },
      queryForm: {
        itemId: '',
        itemQuantity: '',
        companyEntityId: '',
        mmr12: '',
        ledgerAccount: '',
        abiBrandId: '',
        subBrandId: ''
      },
      itemParBrandList: [],
      itemSubBrandList: [],
      showSubBrandList: [],
      subChannelId: [],
      favItemList: [],
      entityList: [],
      total: null,
      itemInfo: {
        itemBrandList: [],
        itemChannelList: []
      },
      queryFormRules: {
        mmr12: [
          { required: true, message: '请选择MMR12类型', trigger: 'change' }
        ],
        ledgerAccount: [
          { required: true, message: '请选择总账科目', trigger: 'change' }
        ],
        companyEntityId: [
          { required: true, message: '请选择工厂', trigger: 'change' }
        ],
        abiBrandId: [
          { required: true, message: '请选择品牌', trigger: 'change' }
        ],
        subBrandId: [
          { required: true, message: '请选择子品牌', trigger: 'change' }
        ]
      },
      companyEntityId: '',
      mmr12List: [],
      ledgerList: []
    }
  },
  watch: {
    'queryForm.mmr12' (val) {
      this.queryForm.ledgerAccount = ''
      this.getLedgerList(val)
    },
    'queryForm.abiBrandId' (val) {
      this.queryForm.subBrandId = ''
    },
    dialogVisible (val) {
      if (!val) {
        this.$nextTick(() => {
          this.$refs.queryForm.resetFields()
          this.queryForm.abiBrandId = ''
        })
      }
    }
  },
  created () {
    this.queryFavItem()
  },
  methods: {
    // 常用物料信息
    queryFavItem () {
      this.listLoading = true
      if (this.itemType === 'menu') {
        this.queryParam.isMenu = '1'
      } else {
        this.queryParam.isPrints = '1'
      }
      itemApi
        .queryFavItemList(this.queryParam)
        .then(res => {
          this.listLoading = false
          if (res.data.resultCode === '0') {
            this.favItemList = res.data.resultData.favoriteItemList
            this.total = res.data.resultData.pageInfo.totalCounts
            this.favItemList.forEach(item => {
              this.$set(item.pocmDTO, 'itemQty', 0)
            })
          }
        })
        .catch(() => {
          this.listLoading = false
        })
    },
    // 总账科目
    getLedgerList (code) {
      if (!code) {
        return
      }
      baseApi.getLedgerList(code).then(res => {
        if (res.data.resultCode === '0') {
          this.ledgerList = res.data.resultData.ledgerList
          if (this.ledgerList.length === 1) {
            this.queryForm.ledgerAccount = this.ledgerList[0].ledgerAccountCode
          }
        }
      })
    },
    // 工厂
    getEntity (id) {
      baseApi.getItemCompany(id).then(res => {
        if (res.data.resultCode === '0') {
          this.entityList = res.data.resultData.companyEntityList
        }
      })
    },

    // 额外费用合计
    getItemSumExtraPrice (item) {
      if (!item) {
        return ''
      }
      item.sumPrice = commonUtils.formatNumber(math.multiply(item.extraFee, item.itemQty / item.priceUnitQuantity)).toFixed(2)
      item.sumPrice = Number(item.sumPrice)
      return item.sumPrice
    },

    // 税额小计
    getItemSumTaxPrice (item) {
      if (item.pocmPriceType === '02') return 0
      let taxPrice = commonUtils.formatNumber(math.multiply(item.taxRate, item.taxExcludedPrice)).toFixed(2)
      let price = commonUtils.formatNumber(math.multiply(taxPrice, item.itemQty / item.priceUnitQuantity)).toFixed(2)
      if (Number(price) < 0.01) price = 0.00
      return price
    },

    // 价格小计
    getItemSumPrice (item) {
      if (!item) {
        return ''
      }
      let price = item.taxExcludedPrice
      let sum = commonUtils.formatNumber(
        math.multiply(item.itemQty / item.priceUnitQuantity, price)
      ).toFixed(2)
      sum = Number(sum)
      return sum
    },

    // 展示品牌
    showBrandName (brandList) {
      const names = []
      brandList.map(brand => {
        names.push(brand.abiBrandName)
      })
      return names.join(',')
    },

    showChannelName (itemChannelList) {
      const names = []
      itemChannelList.map(channel => {
        names.push(channel.channelName)
      })
      return names.join(',')
    },

    // 处理参数
    handleForm (row) {
      this.setBrand(row)
      this.getEntity(row.itemId)
      this.mmr12List = []
      this.mmr12List.push({
        code: row.pocmDTO.mmr12,
        name: row.pocmDTO.mmr12Name
      }, {
        code: row.pocmDTO.nonChannelMmr12,
        name: row.pocmDTO.nonChannelMmr12Name
      })
      this.queryForm.companyEntityId = this.companyEntityId
      this.queryForm.itemId = row.itemId
      this.queryForm.itemQuantity = row.pocmDTO.itemQty
      this.showSelectDialog(row)
    },

    // 弹窗选择品牌和渠道
    showSelectDialog (row) {
      this.dialogVisible = true
    },

    // 关闭弹窗
    closeSelectDialog () {
      this.dialogVisible = false
    },

    // 加入购物车
    saveSelection () {
      this.$refs.queryForm.validate(valid => {
        if (valid) {
          this.saveLoading = true
          this.$store
            .dispatch('addCart', this.queryForm)
            .then(res => {
              this.saveLoading = false
              if (res.data.resultCode === '0') {
                this.$message.success('商品添加购物车成功')
                this.dialogVisible = false
              }
            })
            .catch(() => {
              this.saveLoading = false
              this.$message.error('商品添加购物车失败')
            })
        }
      })
    },

    getPrice (item) {
      if (!item.taxExcludedPrice) return
      return (item.taxExcludedPrice).toFixed(2)
    },

    // 计算税额
    getTaxPrice (item) {
      return (item.taxRate * item.taxExcludedPrice).toFixed(2)
    },

    // 品牌分类
    setBrand (row) {
      let soleBrandFlag = false
      this.itemParBrandList = []
      this.itemSubBrandList = []
      row.pocmDTO.abiBrandList.forEach(brand => {
        if (!brand.parentBrandId || brand.parentBrandId === '0') {
          this.itemParBrandList.push(brand)
        } else {
          this.itemSubBrandList.push(brand)
        }
      })

      // 品牌/子品牌唯一 直接展示
      if (this.itemParBrandList.length === 1 && this.itemSubBrandList.length === 1) {
        soleBrandFlag = true
        this.queryForm.abiBrandId = this.itemParBrandList[0].abiBrandId

        // 子品牌具有品牌组
        if (this.itemSubBrandList[0].brandGroup) {
          this.getSubBrandList(this.queryForm.abiBrandId, soleBrandFlag)
        }
      }
    },

    // 根据品牌联动子品牌下拉内容
    getSubBrandList (id, soleBrandFlag) {
      let arr = []
      // 属于对应的主品牌 且 具有品牌组
      arr = this.itemSubBrandList.filter(item => {
        return item.parentBrandId === id && item.brandGroup
      })
      this.showSubBrandList = arr

      if (soleBrandFlag) {
        this.$nextTick(() => {
          this.queryForm.subBrandId = this.itemSubBrandList[0].abiBrandId
        })
      }
    },

    // 搜索
    handleFilter (value) {
      this.queryParam.abiBrandId = value.abiBrandId
      this.queryParam.channel = value.channel
      this.queryParam.categoryId = value.categoryId
      this.queryParam.keyword = value.keyword
      this.queryParam.minPrice = value.minPrice
      this.queryParam.maxPrice = value.maxPrice
      this.queryParam.entityId = value.entityId
      this.companyEntityId = value.entityId
      this.queryParam.produceSupplierId = value.produceSupplierId
      this.queryFavItem()
    },

    handleCurrentChange (val) {
      this.queryParam.page = val
      this.queryFavItem()
    },

    getImageUrl (item) {
      let imageUri = ''
      if (item.imageList && item.imageList.length > 0) {
        imageUri = item.imageList[0].imageFileUri
      }
      return commonUtils.getImageUrl(imageUri)
    }
    // radio点击取消
    // clickBrand (id) {
    //   if (id === this.queryForm.abiBrandId) {
    //     this.queryForm.abiBrandId = ''
    //   } else {
    //     this.queryForm.abiBrandId = id
    //   }
    // },
    // clickSubBrand (id) {
    //   if (id === this.queryForm.subBrandId) {
    //     this.queryForm.subBrandId = ''
    //   } else {
    //     this.queryForm.subBrandId = id
    //   }
    // },

    // 数量改变时触发
    // quantityChange (newValue, oldValue, row) {
    //   this.$nextTick(() => {
    //     if (newValue % row.pocmDTO.priceUnitQuantity !== 0) {
    //       this.$message.error(
    //         `仅支持以${row.pocmDTO.priceUnitQuantity}倍数量购买`
    //       )
    //       row.pocmDTO.itemQty = oldValue
    //     }
    //   })
    // }
  }
}
</script>

<style lang="scss" scoped>
.button-line {
  height: 80px;
  padding: 20px 0;
}
.item-box {
  min-width: 500px;
}
.item-info-radio {
  font-size: 14px;
  .el-radio-group {
    margin-right: 10px;
  }
  .el-form-item {
    margin-bottom: 15px;
  }
  .el-col-24 {
    height: 42px;
  }
  .el-select {
    width: 260px;
  }
}
.item-btn {
  padding-top: 40px;
  text-align: center;
}
.iconzu19 {
  font-size: 22px;
  color: $base-plain;
}
.item-image {
  width: 70px;
  height: 70px;
  margin: 0 auto;
  border: 1px solid $base-grey;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  img {
    max-width: 95%;
    max-height: 95%;
    border: none;
  }
}
.price-msg {
  font-size: 12px;
  color: #666;
}
.price-info {
  font-size: 12px;
  color: #999;
}
</style>
